import { Nullable } from 'common';
import { formValueSelector } from 'redux-form';
import { AppState } from 'store';
import { UserCustomer } from './models';
import { USER_USAGE_REPORT_FORM } from './UserUsageReport.constants';

export const userUsageReportAccessFlagSelector = ({
  userUsageReport: { accessFlag },
}: AppState): Nullable<boolean> => accessFlag;

export const customersSelector = ({
  userUsageReport: { customers },
}: AppState): Nullable<UserCustomer[]> => customers;

export const valueSelector = (state: AppState, fieldName: string) =>
  formValueSelector(USER_USAGE_REPORT_FORM)(state, fieldName);
